import { faCheck, faCircleExclamation, faFile, faFileAudio, faFilePdf, faPlay } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'
import { BASE_URL } from '../../../../utils/config'
import Modal from '../../modal/Modal'
import styles from './HeroDetail.module.scss'
import { Modal as modal } from 'bootstrap'
import { formatPrice } from '../../../../utils/helper'
import PdfViewer from '../../../global/PdfViewer'

const HeroDetail = ({ category, price, price_zone_1, price_zone_2, price_zone_3, price_zone_4, price_zone_5A, price_zone_5B, id, token, image, slug, bookType, title, het_id, publisher, isbn, edition, writer, attachment, totalDownload, totalRead, totalPlay, type, componentType }) => {
    const [baseURL] = useState(window.location.origin)
    const [loading, setLoading] = useState(false)
    const [failedReview, setFailedReview] = useState(false)
    const [successReview, setSuccessReview] = useState(false)
    const [priceData, setPriceData] = useState(null)
    const [priceLoading, setPriceLoading] = useState(false)
    const { resetField: resetFieldReport, register: registerReport, handleSubmit: handleSubmitReport, formState: { errors: errorsReport } } = useForm();
    const { resetField: resetFieldDownload, register: registerDownload, handleSubmit: handleSubmitDownload, formState: { errors: errorsDownload } } = useForm();

    const onSubmitReport = async (data) => {
        setLoading(true)
        const payload = {
            message: data.message,
            slug: slug,
            category: data.category
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/report/addReport`, JSON.stringify(payload), {
                headers: {
                    Authorization: token,
                },
            })
            if (response.data.status === 'success') {
                setFailedReview(false)
                setSuccessReview(true)
                resetFieldReport('message')
            }
        } catch (error) {
            setSuccessReview(false)
            setFailedReview(true)
            return error.message
        } finally {
            setLoading(false)
        }
    }
    const onSubmitDownload = async (data) => {
        setLoading(true)

        try {
            const response = await axios.post(`${BASE_URL}/api/download/submit`, JSON.stringify(data))
            if (response.data.status === 'success') {
                resetFieldDownload('message')
                window.location.replace(attachment)
            }
        } catch (error) {
            setSuccessReview(false)
            setFailedReview(true)
            return error.message
        } finally {
            setLoading(false)
        }
    }

    const pushLog = async (type) => {
        const payload = {
            slug: slug,
            activity: type
        }

        const convertRAW = JSON.stringify(payload)

        try {
            const response = await axios.post(`${BASE_URL}/api/statistic/push`, convertRAW, {
                headers: {
                    Authorization: token,
                },
            })
            if (response.data.status === 'success') {
                console.log('log pushed');
            }
        } catch (error) {
            console.log('failed log pushed');
        }

    }



    const [imgSrc, setImgSrc] = useState(image);

    const invalidImageUrls = ['https://siplahtelkom.com/assets/images/no-image-available.jpg'];

    useEffect(() => {
        if (!image || invalidImageUrls.includes(image)) {
            setImgSrc('/assets/image/catalog/book-placeholder.jpg');
        } else {
            setImgSrc(image);
        }
    }, [image]);

    const handleDownload = async () => {
        const imageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${baseURL}/qr-handler/${id}?type=${componentType}`;

        try {
            // fetch gambar
            const response = await fetch(imageUrl);
            const blob = await response.blob();

            // buat link virtual untuk download
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `QR Code - ${title}.png`; // nama file hasil download
            document.body.appendChild(a);
            a.click();
            a.remove();

            // bersihkan object url
            window.URL.revokeObjectURL(url);
            } catch (error) {
            console.error("Gagal mendownload QR:", error);
        }
    };

    const fetchPriceData = async () => {
        setPriceLoading(true);
        try {
            const response = await fetch(`https://api.buku.kemendikdasmen.go.id/btucatalogue/detailByPID/${het_id}?code=GuruSejahtera2025`);
            const result = await response.json();
            if (result.meta.status) {
                setPriceData(result.data);
            }
        } catch (error) {
            console.error("Gagal fetch data harga:", error);
        } finally {
            setPriceLoading(false);
        }
    };

    const handleShowHetModal = () => {
        if (!priceData) {
            fetchPriceData();
        }
        const hetModalElement = document.getElementById('hetModal');
        if (hetModalElement) {
            const bsModal = new modal(hetModalElement);
            bsModal.show();
        }
    };

    return (
        <section>
            <div className="container p-4">
                <div className="row p-3 mb-5" style={{ background: 'url(/assets/image/catalog/Background.png)', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPositionX: 'right', borderRadius: '15px' }}>
                    {
                        loading && (
                            <>
                                <div className="col-lg-3">
                                    <Skeleton count={1} height={300} />
                                </div>
                                <div className="col-lg-9 pt-5 pt-md-4">
                                    <Skeleton count={6} height={25} className="mb-2 mt-2" />
                                </div>
                            </>
                        )
                    }
                    {
                        !loading && (
                            <>
                                <div className="col-lg-3 text-center d-flex flex-column align-items-center justify-content-center">
                                    <img src={imgSrc} onError={() => setImgSrc('/assets/image/catalog/book-placeholder.jpg')} className={styles['img-size']} alt="" />
                                </div>
                                <div className="col-lg-9 pt-5 pt-md-0">
                                    {bookType === 'pdf' && <button className="btn btn-sm rounded-pill btn-outline-danger">Buku PDF</button>}
                                    {bookType === 'audio' && <button className="btn btn-sm rounded-pill btn-outline-success">Buku Audio</button>}
                                    {bookType === 'interactive' && <button className="btn btn-sm rounded-pill btn-outline-primary">Buku Interaktif</button>}

                                    <h3 className="my-3">{title}</h3>

                                    {/* Handle type book PDF */}
                                    {
                                        bookType === 'pdf' && attachment ? (
                                            <>
                                                <a onClick={() => pushLog('download')} href={attachment} className="btn btn-sm btn-orange py-2 me-3 my-2" rel="noreferrer" target="_blank" download="file.pdf">
                                                    <FontAwesomeIcon icon={faFilePdf} className="me-1" /> Unduh PDF
                                                </a>
                                                {
                                                    (attachment?.includes('https://static-sc.cloudapp.web.id') || attachment?.includes('https://files.cloudapp.web.id')) ? (
                                                        <button
                                                            onClick={() => {
                                                                pushLog('read');
                                                                const readModalElement = document.getElementById('readModal');
                                                                if (readModalElement) {
                                                                    const readModal = new modal(readModalElement);
                                                                    readModal.show();
                                                                }
                                                            }}
                                                            className="btn btn-sm btn-outline-primary py-2"
                                                        >
                                                            <FontAwesomeIcon icon={faFilePdf} className="me-1" /> Baca Online
                                                        </button>
                                                    ) : (
                                                        <a 
                                                            onClick={() => pushLog('read')} 
                                                            href={attachment} 
                                                            className="btn btn-sm btn-outline-primary py-2 me-3 my-2" 
                                                            rel="noreferrer" 
                                                            target="_blank"
                                                        >
                                                            <FontAwesomeIcon icon={faFilePdf} className="me-1" /> Baca Online
                                                        </a>
                                                    )
                                                    
                                                }
                                                <small className="my-3 text-muted d-block">{totalDownload ? `Telah di-unduh ${totalDownload} kali` : null} <a href={`https://app.buku.kemendikdasmen.go.id/sistem-pengawasan?book_slug=${slug}`} target="_blank" className="text-decoration-none text-blue ms-1 fw-bold" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faCircleExclamation} /> Lapor disini</a> jika menemukan kesalahan pada buku</small>
                                            </>
                                        ) : (
                                            <>
                                                {type === 'penilaian' && (
                                                    <a
                                                        href={`https://search.siplah.kemendikdasmen.go.id/search?keyword=${title}`}
                                                        className="btn btn-sm btn-orange py-2 mb-3"
                                                        target="_blank"
                                                    >
                                                        <FontAwesomeIcon icon={faFilePdf} className="me-1" /> Beli Buku
                                                    </a>
                                                )}
                                            </>
                                        )
                                    }

                                    {/* Handle book type audio */}
                                    {
                                        bookType === 'audio' && attachment && (
                                            <>
                                                <a 
                                                    onClick={() => {
                                                        pushLog('play');
                                                        window.location.href = "#audioPlayer";
                                                    }} 
                                                    href="#" 
                                                    className="btn btn-sm btn-orange py-2 me-3 my-2"
                                                >
                                                    <FontAwesomeIcon icon={faPlay} className="me-2" /> Putar Audio
                                                </a>
                                                <a onClick={() => pushLog('download')} href={attachment} className="btn btn-sm btn-outline-primary py-2" target="_blank" rel="noreferrer" download="file.pdf">
                                                    <FontAwesomeIcon icon={faFileAudio} className="me-1" /> Unduh PDF
                                                </a>
                                                <small className="my-3 text-muted d-block">{totalPlay ? `Telah diputar ${totalPlay} kali` : null} <a data-bs-toggle="modal" data-bs-target="#reportModal" className="text-decoration-none text-blue ms-1 fw-bold" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faCircleExclamation}/> Lapor disini</a> jika menemukan kesaahan pada audio</small>
                                            </>
                                        )
                                    }

                                    {/* Handle book type interactive */}
                                    {
                                        bookType === 'interactive' && attachment && (
                                            <>
                                                <a 
                                                    onClick={() => {
                                                        pushLog('read');
                                                        window.open(attachment, '_blank', 'noopener,noreferrer');
                                                    }} 
                                                    href="#" 
                                                    className="btn btn-sm btn-orange py-2 me-3 my-2"
                                                >
                                                    <FontAwesomeIcon icon={faFile} className="me-2" />Baca Buku Interaktif
                                                </a>
                                                <small className="my-3 text-muted d-block">{totalDownload ? `Telah di-unduh ${totalDownload} kali` : null} <a data-bs-toggle="modal" data-bs-target="#reportModal" className="text-decoration-none text-blue ms-1 fw-bold" style={{ cursor: 'pointer' }}><FontAwesomeIcon icon={faCircleExclamation} /> Lapor disini</a> jika menemukan kesalahan pada naskah</small>
                                            </>
                                        )
                                    }

                                    <div className="row align-items-center mb-3">
                                        <div className="col-6 col-lg-2">
                                           <span>DETAIL BUKU</span>
                                        </div>
                                        <div className="col-5 col-lg-10 p-0">
                                            <hr />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-2 mb-2 mb-md-0">
                                            <div>Penerbit</div>
                                            {publisher ? <small className="text-muted">{publisher}</small> : '-'}
                                        </div>
                                        <div className="col-lg-3 mb-2 mb-md-0">
                                            <div>ISBN</div>
                                            {isbn ? <small className="text-muted">{isbn}</small> : '-'}
                                        </div>
                                        <div className="col-lg-2 mb-2 mb-md-0">
                                            <div>Edisi</div>
                                            {edition ? <small className="text-muted">{edition}</small> : '-'}
                                        </div>
                                        <div className="col-lg-3 mb-2 mb-md-0">
                                            <div>Penulis</div>
                                            {writer ? <small className="text-muted">{writer}</small> : '-'}
                                        </div>
                                        {
                                            type !== 'penilaian' && (
                                                <div className="col-lg-2 mb-2 mb-md-0">
                                                <div>HET</div>
                                                    {price_zone_1 === null && <small className="text-muted">Belum ada</small>}
                                                    {price_zone_1 !== null && (
                                                        <>
                                                            {/* <small className="text-muted">Rp {formatPrice(price_zone_1)}</small> */}
                                                            {/* {category !== 'buku_non_teks' && (<small type="button" className="text-primary d-block" data-bs-toggle="modal" data-bs-target="#hetModal">Lihat zona..</small>)} */}
                                                            {/* {category === 'buku_non_teks' && (<a href={`https://app.buku.kemendikdasmen.go.id/penilaian?title=${title}&type=bntp`} target="_blank" rel="noreferrer" className="text-primary d-block text-decoration-none small">Lihat Harga</a>)}
                                                            {category === 'buku_sekolah_penggerak' && (<a href={`https://app.buku.kemendikdasmen.go.id/penilaian?title=${title}&type=btp`} target="_blank" rel="noreferrer" className="text-primary d-block text-decoration-none small">Lihat Harga</a>)} */}
                                                            <button onClick={handleShowHetModal} className="text-primary d-block text-decoration-none small" style={{background: 'none', border: 'none', cursor: 'pointer', padding: 0}}>Lihat Harga</button>
                                                        </>
                                                    )}
                                                </div>
                                                
                                            )
                                        }
                                        {
                                            type === 'penilaian' && componentType === 'bntpcatalogue' && price && (price_zone_1 === '-') && (
                                                <div className="col-lg-2 mb-2 mb-md-0">
                                                <div>Harga</div>
                                                    {`Rp ${formatPrice(price)}`}
                                                </div>
                                                
                                            )
                                        }
                                    </div>
                                    {
                                        type == 'penilaian' && (componentType === 'btpcatalogue' || componentType === 'btucatalogue' || (componentType === 'bntpcatalogue' && (price_zone_1 !== '-')))  && (
                                            <div>
                                                <div className="row mt-3">
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 1</div>
                                                        <small className="text-muted">{price_zone_1 === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_1)}`}</small>
                                                    </div>
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 2</div>
                                                        <small className="text-muted">{price_zone_2 === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_2)}`}</small>
                                                    </div>
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 3</div>
                                                        <small className="text-muted">{price_zone_3 === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_3)}`}</small>
                                                    </div>
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 4</div>
                                                        <small className="text-muted">{price_zone_4 === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_4)}`}</small>
                                                    </div>
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 5A</div>
                                                        <small className="text-muted">{price_zone_5A === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_5A)}`}</small>
                                                    </div>
                                                    <div className="col-lg-2 mb-2 mb-md-0">
                                                        <div>Zona 5B</div>
                                                        <small className="text-muted">{price_zone_5B === null ? 'Belum ada' : `Rp ${formatPrice(price_zone_5B)}`}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                    {
                                        type == 'penilaian' && (
                                            <div className="text-start">
                                                {/* <img src={`https://api.qrserver.com/v1/create-qr-code/?size=100x1000&data=${baseURL}/qr-code/${id}?type=${componentType}`} width={100} className="img-fluid mb-2" alt="" /> */}
                                                <div class="mt-5">
                                                    <small>
                                                        <b>Catatan</b> : Penerbit? Unduh Kode QR HET untuk disematkan pada kover buku. 
                                                        Silakan klik <a href="#" role="button" onClick={handleDownload}>disini</a>
                                                        .<br/>Belum tahu istilah Zona dalam HET? pelajari <a href="#" type="button" data-bs-toggle="modal" data-bs-target="#zonaModal">disini</a>
                                                    </small>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
            <Modal id="readModal" title={title} className="modal-dialog-scrollable">
                {!!attachment && (
                    <div className="pdf-viewer-container" style={{ height: '80vh', overflow: 'auto' }}>
                        {window.innerWidth >= 1024 ? (
                            <object
                                data={attachment}
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                className="d-block mx-auto"
                            >
                                <p>Your browser doesn't support PDF viewing. Please download the PDF to view it.</p>
                            </object>
                        ) : (
                            <PdfViewer url={attachment} />
                        )}
                    </div>
                )}
            </Modal>
            <div className="modal fade" id="reportModal" tabIndex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
                <div className="modal-dialog m-0">
                    <div className="modal-content bg-">
                        <div className="modal-header bg-warning">
                            <h5 className="modal-title" id="reportModalLabel"><FontAwesomeIcon icon={faCircleExclamation} /> Laporkan Buku</h5>
                            <button onClick={() => { setSuccessReview(false); setFailedReview(false) }} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmitReport(onSubmitReport)}>
                            <div className="modal-body bg-soft-grey">
                                {failedReview && <div className="alert alert-warning">Silahkan <Link to="/login" className="text-decoration-none">login</Link> terlebih dahulu.</div>}
                                {successReview && <div className="alert alert-success">Laporan berhasil dikirim <FontAwesomeIcon className="ms-1" icon={faCheck} /></div>}
                                <div className="form-group mb-3">
                                    <label className="form-label" htmlFor="kategori">Kategori</label>
                                    <select {...registerReport('category', { required: true })} id="kategori" className="form-select">
                                        <option value="Sara">Sara</option>
                                        <option value="Salah Cetak">Salah Cetak</option>
                                        <option value="Plagiasi">Plagiasi</option>
                                        <option value="Lainnya">Lainnya</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <textarea {...registerReport('message', { required: true })} className="form-control" rows="3" placeholder="Pesan"></textarea>
                                    {errorsReport.message && errorsReport.message.type === 'required' && <small className="text-danger">Pesan laporan harus diisi</small>}
                                </div>
                            </div>
                            <div className="modal-footer bg-soft-grey">
                                {
                                    loading
                                        ? (<button type="button" className="btn btn-primary disabled btn-sm"><div className="spinner-border" role="status"></div></button>)
                                        : (<button type="submit" className="btn rounded-pill bg-blue text-white">Kirim</button>)
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="downloadModal" tabIndex="-1" aria-labelledby="downloadModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content bg-">
                        <div className="modal-header bg-light text-white">
                            <button onClick={() => { setSuccessReview(false); setFailedReview(false) }} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={handleSubmitDownload(onSubmitDownload)}>
                            <div className="modal-body bg-soft-grey">
                                <p>Mohon isi data di bawah ini sebelum mengunduh buku :</p>
                                <input type="hidden" {...registerDownload('download_file')} value={id} />
                                <div className="form-group mb-3">
                                    <label className="form-label" htmlFor="name">Nama</label>
                                    <input id="name" type="text" {...registerDownload('name', { required: true })} className="form-control" placeholder="Masukan nama" />
                                    {errorsDownload.name && errorsDownload.name.type === 'required' && <small className="text-danger">Nama harus diisi</small>}
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label" htmlFor="email">Email</label>
                                    <input type="email" id="email" {...registerDownload('email', { required: true })} className="form-control" placeholder="Masukan email" />
                                    {errorsDownload.email && errorsDownload.email.type === 'required' && <small className="text-danger">Email harus diisi</small>}
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label" htmlFor="phone">Nomor HP</label>
                                    <input id="phone" type="text" {...registerDownload('phone', { required: true })} className="form-control" placeholder="Masukan nomor HP" />
                                    {errorsDownload.phone && errorsDownload.phone.type === 'required' && <small className="text-danger">Nomor HP harus diisi</small>}
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label" htmlFor="city">Kota</label>
                                    <input id="city" type="text" {...registerDownload('city', { required: true })} className="form-control" placeholder="Masukan kota" />
                                    {errorsDownload.city && errorsDownload.city.type === 'required' && <small className="text-danger">Asal kota harus diisi</small>}
                                </div>
                            </div>
                            <div className="modal-footer bg-soft-grey">
                                {
                                    loading
                                        ? (<button type="button" className="btn btn-primary disabled btn-sm"><div className="spinner-border" role="status"></div></button>)
                                        : (<button type="submit" className="btn rounded-pill bg-blue text-white">Kirim dan Unduh</button>)
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="hetModal" tabIndex="-1" aria-labelledby="hetModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content bg-light">
                        <div className="modal-header">
                            <h5 className="modal-title" id="hetModalLabel">Daftar HET</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {priceLoading ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status"></div>
                                </div>
                            ) : priceData && priceData.book_prices && priceData.book_prices.length > 0 ? (
                                <table className="table table-striped">
                                    <tbody>
                                        {priceData.book_prices.map((item) => (
                                            <tr key={item.id}>
                                                <td>Zona {item.zone.toUpperCase()}</td>
                                                <td>Rp {formatPrice(parseInt(item.price))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="alert alert-info">
                                    <p className="mb-2">Data harga untuk buku ini tidak tersedia di saat ini.</p>
                                    <p className="mb-0">Silakan akses <a href="https://buku.kemendikdasmen.go.id/hasil-penilaian" target="_blank" rel="noreferrer" className="text-decoration-none fw-bold">halaman hasil penilaian</a> dan cari judul buku secara langsung untuk melihat informasi harga terkini.</p>
                                </div>
                            )}
                            <small type="button" className="text-primary d-block" data-bs-toggle="modal" data-bs-target="#zonaModal">Pelajari Zona</small>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="zonaModal" data-bs-backdrop="static">
                <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Keterangan Zona</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td width={80}>Zona 1</td>
                                        <td>Jawa Barat, Jawa Tengah, Jawa Timur, Daerah Istimewa Yogyakarta, DKI Jakarta, dan Banten</td>
                                    </tr>
                                    <tr>
                                        <td>Zona 2</td>
                                        <td>Bali, Nusa Tenggara Barat, Lampung (kecuali (i) Pesisir Barat), dan Sumatera Selatan.</td>
                                    </tr>
                                    <tr>
                                        <td>Zona 3</td>
                                        <td>Bengkulu, Jambi, Bangka Belitung,  Sumatera  Barat  (kecuali  (i)  Kepulauan  Mentawai  dan  (ii)  Solok Selatan), Riau (kecuali (i) Bengkalis, (ii) Kepulauan Meranti, (iii) , Sumatera Utara (kecuali (i) Nias, (ii) Nias Selatan, (iii) Nias Utara, (iv) Nias Barat), Sulawesi Selatan, Sulawesi Utara (kecuali (i) Kepulauan Sangihe, dan (ii) Kepulauan Talaud), Sulawesi Tengah (kecuali  (i)  Banggai  Kepulauan,  (ii)  Tojo  Uno- Uno, (iii) Sigi, dan (iv) Banggai Laut), Sulawesi Barat, Sulawesi Tenggara (Kecuali (i) Konawe,  (ii) Bombana, dan (iii) Konawe Kepulauan), dan Gorontalo.</td>
                                    </tr>
                                    <tr>
                                        <td>Zona 4</td>
                                        <td>Nanggroe Aceh Darussalam (kecuali (i) Aceh Besar dan (ii) Aceh Singkil), Kepulauan Riau (kecuali (i) Karimun, (ii)  Kepulauan Anambas, dan (iii)  Natuna), Nusa  Tenggara  Timur (kecuali (i) Sumba Barat, (ii) Sumba  Timur,  (iii)  Timor  Tengah  Selatan,  (iv)  Belu,  (v)  Alor,  (vi)  Lembata,  (vii)  Ende,  (viii) Manggarai,   (ix)   Rote   Ndao,   (x)   Manggarai   Barat,   (xi)   Sumba   Tengah,   (xii)   Sumba   Barat   Daya,   (xiii) Nagekeo, (xiv) Manggarai Timur, (xv) Sabu Raijua, dan (xvi) Malaka), Kalimantan  Barat  (kecuali  (i) Kapuas Hulu, (ii) Sanggau), Kalimantan Selatan, Kalimantan Tengah, Kalimantan Timur (kecuali (i) Mahakam Hulu, (ii) Berau), Kalimantan  Timur,  dan  Kalimantan  Utara  (kecuali  (i)  Nunukan,  (ii) Malinau.</td>
                                    </tr>
                                    <tr>
                                        <td>Zona 5A</td>
                                        <td>(1) Aceh  Besar,  (2)  Aceh  Singkil,  (3)  Nias,  (4)  Nias  Selatan,  (5)  Nias  Utara,  (6)  Nias  Barat,  (7)  Kep. Mentawai,  (8)  Solok  Selatan,  (9)  Pesisir  Barat,  (10)  Sumba  Barat,  (11)  Sumba  Timur,  (12)  Timor Tengah Selatan, (13) Belu, (14) Alor, (15) Lembata, (16) Ende, (17) Manggarai, (18) Rote Ndao, (19) Manggarai Barat, (20) Sumba  Tengah,  (21) Sumba Barat Daya, (22)  Nagekeo, (23) Manggarai Timur, (24) Sabu Raijua, (25) Malaka, (26) Banggai  Kepulauan,  (27)  Tujo  Una-Una,  (28)  Sigi,  (29)  Banggai Laut, (30) Konawe, (31) Bombana, (32) Konawe Kepulauan, (33) Bengkalis, (34) Kepulauan Meranti, (35) Karimun, (36) Kepulauan Anambas, (37) Natuna, (38) Kapuas Hulu, (39) Mahakam Hulu, (40) Sanggau, (41) Nunukan, (42) Malinau,  (43)  Berau,  (44)  Kepulauan Sangihe, dan (45) Kepulauan Talaud.</td>
                                    </tr>
                                    <tr>
                                        <td>Zona 5B</td>
                                        <td>Papua, Papua Barat, Maluku, dan Maluku Utara</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroDetail